import { Button } from '@insight-health-ai/roseate/components';
import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';

type DateRangePickerProps = Pick<RangePickerProps, 'value' | 'onChange'>;

const getQuickFilter = () =>
  [
    {
      label: 'Today',
      value: [dayjs(), dayjs()],
    },

    {
      label: 'Yesterday',
      value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
    },

    {
      label: 'Last 7 Days',
      value: [dayjs().subtract(7, 'day'), dayjs()],
    },

    {
      label: 'Last 30 Days',
      value: [dayjs().subtract(30, 'day'), dayjs()],
    },
  ] as const;

export const DateRangePicker = ({ value, onChange }: DateRangePickerProps) => {
  return (
    <>
      <style>
        {`.calls-date-picker-popup .ant-picker-panel-layout {
            > div {
              display: flex;
              flex-direction: column-reverse;
            }
          }`}
      </style>
      <DatePicker.RangePicker
        allowEmpty
        allowClear
        width={'fit-content'}
        value={value}
        classNames={{
          popup: {
            root: 'calls-date-picker-popup',
          },
        }}
        onChange={(value, dateString) => {
          onChange?.(
            [
              value?.[0]?.startOf('day') ?? null,
              value?.[1]?.endOf('day') ?? null,
            ],
            [dateString?.[0] ?? null, dateString?.[1] ?? null]
          );
        }}
        format={(value) => {
          if (!value) return '';

          const dateStr = dayjs(value).isSame(dayjs(), 'year')
            ? dayjs(value).format('MMM DD')
            : dayjs(value).format('MMM DD, YY');

          return dateStr;
        }}
        renderExtraFooter={() => (
          <div className="flex gap-2 py-4 justify-between items-center">
            <div className="flex gap-2 flex-wrap">
              {getQuickFilter().map((item) => {
                const selected =
                  value &&
                  dayjs(value[0]).isSame(item.value[0], 'day') &&
                  dayjs(value[1]).isSame(item.value[1], 'day');
                return (
                  <Button
                    size="sm"
                    shape="round"
                    variant={selected ? 'solid' : 'outlined'}
                    appearance="primary"
                    key={item.label}
                    onClick={() =>
                      onChange?.(
                        [item.value[0], item.value[1]],
                        [
                          item.value[0]?.toISOString(),
                          item.value[1]?.toISOString(),
                        ]
                      )
                    }
                  >
                    {item.label}
                  </Button>
                );
              })}
            </div>
            <a
              className="text-xs text-gray-600 font-semibold"
              onClick={() => {
                onChange?.(null, ['', '']);
              }}
            >
              Clear
            </a>
          </div>
        )}
      />
    </>
  );
};
